export interface PriceColor {
  color: string;
}

const DEFAULT_COLORS: PriceColor[] = [
  { color: "#48A4FF" },
  { color: "#8C5F00" },
  { color: "#6093B8" },
  { color: "#BCE3FF" },
  { color: "#00C6A7" },
  { color: "#003357" },
  { color: "#006B61" },
  { color: "#FFE2A6" }
];

const PRICE_COLORS: PriceColor[] = [
  { color: "#005595" }, // Blue for regular
  ...DEFAULT_COLORS
];

const MEMBERS_EXCLUSIVE_PRICE_COLORS: PriceColor[] = [
  { color: "#DAA400" }, // Yellow for members exclusive
  ...DEFAULT_COLORS
];

export function getPriceColors(isMembersExclusive: boolean = false): PriceColor[] {
  return isMembersExclusive ? MEMBERS_EXCLUSIVE_PRICE_COLORS : PRICE_COLORS;
}
